import { Theme } from "@mui/material/styles";
import sunoShadows from "app/themes/shadows";

export const getPopoverComponents = (sunoTheme: Theme) => ({
  MuiPopover: {
    styleOverrides: {
      paper: {
        boxShadow: sunoShadows[0],
      },
    },
  },
});
